import { ErrorBoundary as EBoundary } from '@ori/presentation-components';
import { ProductBoxSkeleton } from "./ProductBoxSkeleton";
import { jsx as _jsx } from "react/jsx-runtime";
export var ErrorBoundary = function ErrorBoundary(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(EBoundary, {
    fallback: /*#__PURE__*/_jsx(ProductBoxSkeleton, {
      animation: "pulse"
    }),
    children: children
  });
};
//# sourceMappingURL=ErrorBoundary.js.map